export function getAppFromSpaWrapper() {
  let application = null;
  const appContainer = document.getElementById("vacv-spa-search-container");
  if (appContainer) {
    application = appContainer.querySelector("#app-search");
  }
  return application;
}

export function getConfig() {
  const app = getAppFromSpaWrapper();
  if (app instanceof HTMLElement && app.dataset?.vars) {
    return JSON.parse(app.dataset.vars);
  }
  return null;
}

export const config = getConfig();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getEnvVarFromConfig(cfg: { [key: string]: any }, name: string) {
  return cfg?.[name] ? cfg[name] : import.meta.env[name];
}

export function getEnvVar(name: string) {
  return getEnvVarFromConfig(config, name);
}
